import { arrayOf, bool, oneOf, number, shape, string } from 'prop-types'
import { ControlFlags } from '../../models/common/control-flags-enum'
import { PasswordStatus } from '../../models/users/password-status-enum'
import { UserStates } from '../../models/users/user-states-enum'

const { RESET_PASSWORD } = ControlFlags

export const userPropType = shape({
    company: string,
    controlFlags: arrayOf(oneOf([RESET_PASSWORD])),
    email: string,
    enabled: bool,
    failedLogins: number,
    lastLoginTime: string,
    lastPasswordChangeTime: string,
    passwordInfo: shape({
        forceChange: bool,
        status: oneOf(Object.values(PasswordStatus))
    }),
    profileId: string,
    realName: string,
    state: oneOf(Object.values(UserStates)).isRequired,
    userId: string.isRequired,
    userInfo: string,
    userName: string.isRequired,
    validFromDate: string,
    validToDate: string
})
